import { Component, OnInit, Output, Input } from '@angular/core';
import { ChartService } from 'src/app/services/chart.service';

@Component({
    selector: 'app-tab1',
    templateUrl: './tab1.component.html'
})
export class Tab1Component implements OnInit {

    public images = [];
    public data: any = {};

    @Input() lb: any;
    @Input() print: boolean;

    constructor(
        private chartService: ChartService
    ) { }

    ngOnInit() {
        this.chartService.notReadyForPrint();
        this.lb.widgets['dc-home'].ds.out$.subscribe(data => {
            this.data = data;
            if (this.print) {
                setTimeout(() => {
                        this.chartService.convertToImage([
                            'profit-chart',
                            'ebitda-chart',
                            'revenues-chart',
                            'centrality-score-chart',
                            'cgrp4-chart',
                            'cgrp15-chart'], this.images).then(() => {
                            this.chartService.readyForPrint();
                        });
                    
                }, this.chartService.waitTime);
            }
        });
    }

    isDate(d) {
        return d && d != '1900-01-01';
    }

}
